import React, { useState, useEffect } from 'react';
import ContentLabel from 'views/Content/ContentLabel';
import axios from 'axios';
import { Container, Row, Col } from 'reactstrap';
import HtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { OLD_API_URL, IMAGE_BASE_URL } from 'utils/constants';

export default function Research() {
    const [infoJST, setinfoJST] = useState({});
    const [infoAnnouc, setinfoAnnouc] = useState([]);

    useEffect(() => {
        const requestUrlPublication = `${OLD_API_URL}/jst_cover/active?unit=Home`;
        const requestUrlPatent = `${OLD_API_URL}/jst_announcements?unit=Home`;

        axios.get(requestUrlPublication).then(response => {
            setinfoJST(response.data || {});
        }).catch(error => {
            console.error("Lỗi gọi API!", error);
        });

        axios.get(requestUrlPatent).then(response => {
            setinfoAnnouc(response.data || []);
        }).catch(error => {
            console.error("Lỗi gọi API!", error);
        });
    }, []);

    return (
        <div className="journal" style={{ color: '#2b2b2b' }}>
            <Container>
                <Row>
                    <Col md='12' sm='12'>
                        <ContentLabel tittle="Journal of Science and Technique" />
                    </Col>
                </Row>
                
                <Row style={{ marginTop: '35px' }}>
                    {/* Bìa báo & Current Issue */}
                    <Col md='3' sm='6'>
                        <a href={infoJST.current_issue} target="_blank" rel="noopener noreferrer">
                            <img src={`${IMAGE_BASE_URL}/${infoJST.image}`} className="img-fluid" alt="Journal Cover" />
                        </a>
                        <div style={{ marginTop: '10px' }}>
                            <a 
                                href={infoJST.current_issue} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="currentIssue"
                                style={{
                                    color: '#0056b3',
                                    fontWeight: '700',
                                    fontSize: '16px',
                                    textDecoration: 'none'
                                }}
                            >
                                Current Issue
                            </a>
                        </div>
                    </Col>

                    {/* About LQDTU-JST */}
                    <Col md='3' sm='6'>
                        <a href="https://jst.lqdtu.edu.vn/index.php/jst/AS" className="about_link_journal" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                            <div className="topic">
                                <div className="topic_header" style={{ marginBottom: '8px' }}>
                                    <span style={{ color: '#004085', fontWeight: '700', fontSize: '18px' }}>
                                        About LQDTU-JST
                                    </span>
                                </div>
                                <div className="topic_content">
                                    <p className="topic_title" style={{ color: '#0056b3', fontWeight: '600', fontSize: '15px', lineHeight: '1.4', marginBottom: '8px' }}>
                                        Welcome to Journal of Science & Technique of Le Quy Don Technical
                                    </p>
                                    <p className="topic_description" style={{ color: '#333333', fontWeight: '400', fontSize: '14px', lineHeight: '1.5' }}>
                                        LQDTU-JST is a peer-reviewed double-blind journal with international publication code ISSN 1859-0209 for issue of 12 annual editions.
                                    </p>
                                </div>
                            </div>
                        </a>
                    </Col>

                    {/* Announcements */}
                    <Col md='6' sm='12'>
                        <div className="announcement">
                            <div className="announcement_header" style={{ marginBottom: '12px', borderBottom: '2px solid #0056b3', paddingBottom: '4px' }}>
                                <span style={{ color: '#004085', fontWeight: '700', fontSize: '18px' }}>
                                    Announcements
                                </span>
                            </div>
                            
                            {infoAnnouc && infoAnnouc.map((item, index) => {
                                return (
                                    <div className="announcement_content" key={item.id || index} style={{ marginBottom: '16px' }}>
                                        <div className={`post-item ${index === 0 ? 'line-post-item' : 'pb-0'}`}>
                                            <div className="event-caption">
                                                <div className="right-box">
                                                    {/* Tiêu đề thông báo */}
                                                    <a 
                                                        href={item.link} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer" 
                                                        className="topic_title_announce"
                                                        style={{
                                                            color: '#0056b3',
                                                            fontWeight: '700',
                                                            fontSize: '16px',
                                                            lineHeight: '1.4',
                                                            display: 'block',
                                                            marginBottom: '6px',
                                                            textDecoration: 'none'
                                                        }}
                                                    >
                                                        {item.title}
                                                    </a>
                                                    
                                                    {/* Nội dung thông báo */}
                                                    <div 
                                                        className="topic_description_announce"
                                                        style={{
                                                            color: '#2d3748',
                                                            fontWeight: '400',
                                                            fontSize: '14px',
                                                            lineHeight: '1.6'
                                                        }}
                                                    >
                                                        {HtmlParser(item.content)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}